import { useCallback } from 'react';
import { useSupplierCreateMutation } from 'api';
import { Form, notification } from 'components';
import { ErrorMappingValueType } from 'typings';

export const useAddSupplier = (props: { onModalStateChange: () => void }) => {
  const [form] = Form.useForm();
  const { onModalStateChange } = props;
  const [createSupplier, { isLoading }] = useSupplierCreateMutation();

  const [notificationApi, contextHolder] = notification.useNotification();
  const triggerNotification = useCallback(
    (messageContent: ErrorMappingValueType) => {
      const { type, message } = messageContent;
      notificationApi[type]({ message });
    },
    [notificationApi]
  );

  const onCancel = useCallback(() => {
    form.resetFields();
    onModalStateChange();
  }, [form, onModalStateChange]);

  const onFinish = useCallback(async () => {
    try {
      const payload = form.getFieldsValue() || {};
      payload.name = payload.name.trim();
      payload.webSite = payload.webSite ? payload.webSite : undefined;
      const { data, error }: any = await createSupplier(payload);
      if (data?.success) {
        triggerNotification({
          type: 'success',
          message: 'Supplier was successfully created.',
        });
        onCancel();
      } else if (error?.data?.success === false) {
        Object.values(error?.data?.data || {}).forEach((message) => {
          triggerNotification({
            type: 'error',
            message: message as string,
          });
        });
      } else if (error?.data?.error) {
        triggerNotification({
          type: 'error',
          message: 'Something went wrong!',
        });
      }
    } catch (err) {
      console.error('Error adding supplier:', err);
      triggerNotification({
        type: 'error',
        message: 'An unexpected error occurred. Please try again.',
      });
    }
  }, [createSupplier, triggerNotification, form, onCancel]);

  return {
    form,
    onCancel,
    onFinish,
    contextHolder,
    isLoading,
  };
};
